import anim from '~/assets/anim.riv'

import { cn } from '@forest/shared'
import { Fit, Layout, Rive } from '@rive-app/canvas'
import { createSignal, onCleanup, onMount } from 'solid-js'

export function FrontBgAnim() {
  const [isLoaded, setIsLoaded] = createSignal(false)
  let canvas!: HTMLCanvasElement
  let rive: Rive
  onMount(() => {
    rive = new Rive({
      canvas,
      src: anim,
      artboard: 'landing_page',
      stateMachines: ['State Machine 1'],
      layout: new Layout({ fit: Fit.FitHeight }),
      autoplay: true,
      onLoad: () => {
        rive.resizeDrawingSurfaceToCanvas()
        setIsLoaded(true)
      },
    })
  })
  onCleanup(() => {
    rive?.cleanup()
  })
  return (
    <canvas
      class={cn(
        'h-full w-full transition-opacity',
        isLoaded() ? 'opacity-100' : 'opacity-0',
      )}
      ref={canvas}
    />
  )
}
